import { render, staticRenderFns } from "./ItemLayout.vue?vue&type=template&id=607395d2&scoped=true"
import script from "./ItemLayout.vue?vue&type=script&lang=js"
export * from "./ItemLayout.vue?vue&type=script&lang=js"
import style0 from "./ItemLayout.vue?vue&type=style&index=0&id=607395d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607395d2",
  null
  
)

export default component.exports